import React, { memo, useCallback, useMemo, useState } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DatePublishedContent from 'Pods/SearchPage/Shared/DatePublishedContent/DatePublishedContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearDatePublished } from 'Pods/SearchPage/Store/actions/datePublished'
import { DATE_PUBLISHED } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'


function DatePublished() {
  const translate = useTranslate()

  const datePublished = useSearchPageStore(state => state.datePublished ?? DATE_PUBLISHED.ALL_TIME)
  const [triggerCloseDropdown, setTriggerCloseDropdown] = useState(false)

  const hasSelectedAnyFilter = datePublished !== DATE_PUBLISHED.ALL_TIME

  const handleReset = useCallback(() => {
    clearDatePublished()
  }, [])

  // Applying a custom range is a committing action, so the dropdown steps out of the way and
  // leaves the filtered results visible.
  const handleApply = useCallback(() => {
    setTriggerCloseDropdown(true)
  }, [])

  const content = useMemo(() => (
    <>
      <DatePublishedContent onApply={handleApply} />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleApply, handleReset, hasSelectedAnyFilter])

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.date_published.title')}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      triggerCloseDropdown={triggerCloseDropdown}
      setTriggerCloseDropdown={setTriggerCloseDropdown}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(DatePublished)
